import { Card } from '@sravni/react-design-system/lib/Card';
import { Layout } from '@sravni/react-design-system/lib/Layout';
import { Space } from '@sravni/react-design-system/lib/Space';
import { Heading } from '@sravni/react-design-system/lib/Typography';
import { useIsMobile, useStyles } from '@sravni/react-utils';

import { Mite } from '../../Mite';
import { StrahovanieNedvizhimosti } from '../../StrahovanieNedvizhimosti';
import { Tourist } from '../../Tourist';
import image from '../images/flashLight.png';
import styles from '../styles/Container.module.scss';
import { ContainerProps } from '../types/Container.types';

export const Container = ({ className, ...rest }: ContainerProps) => {
  const isMobile = useIsMobile();
  const cx = useStyles(styles);

  const containerClassNames = cx(className, {
    'h-pt-24': isMobile,
    'h-pt-32': !isMobile,
  });

  return (
    <Space direction="column" size={isMobile ? 16 : 24} className={containerClassNames} {...rest}>
      <Layout>
        <Space align="center" size={12} direction="row">
          <Heading level={3}>Сезонные предложения</Heading>
          <img src={image} height={32} width={32} alt="" />
        </Space>
      </Layout>
      <Layout className={styles.layout}>
        <Card size={isMobile ? 16 : 24} color="light" className={styles.cardContainer}>
          <Space direction="row" size={isMobile ? 16 : 24} className={styles.offersWrapper}>
            <StrahovanieNedvizhimosti />
            <Tourist />
            <Mite />
          </Space>
        </Card>
      </Layout>
    </Space>
  );
};
